import { useMemo } from 'react';
import { compact, get, keys } from 'lodash';
import { useGridSettings } from 'components/SearchResultsMUI/useGridSettings';

export const useFilterableColumns = (gridKey: string, columns: any[]) => {
  const { getGridColumnsVisibility } = useGridSettings();

  const columnVisibilityModel = getGridColumnsVisibility(gridKey);

  // Compute hidden columns not to be shown in filters
  const hiddenColumns = useMemo(
    () =>
      compact(
        keys(columnVisibilityModel).map((columnName) =>
          get(columnVisibilityModel, columnName) === false ? columnName : undefined,
        ),
      ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(columnVisibilityModel)],
  );

  const filterableColumns = useMemo(
    () =>
      columns.map((column) => ({
        ...column,
        filterable:
          column.type !== 'actions' &&
          !hiddenColumns.includes(column.field) &&
          get(column, 'filterable', true),
      })),
    [columns, hiddenColumns],
  );

  return filterableColumns;
};
